module.exports = __webpack_public_path__ + "img/conference.548b171e.jpg";